import React from 'react';
import isEmpty from 'lodash/isEmpty';

import { AntdAlert as Alert } from '@yuhuinc/ui-library/';
import { toFriendlyDateString } from 'helpers/Formatter';
import { getTranslatedString } from 'helpers/i18n';

const LeaseRejectedAlert = ({ latestLeaseReview }) => {
  if (isEmpty(latestLeaseReview)) return;

  return (
    <Alert
      closable={false}
      message={
        <div>{`${getTranslatedString(
          'landlordPortal.leaseCreatorV2.leaseReview.status'
        )}: ${getTranslatedString('landlordPortal.leaseCreatorV2.leasePreviewPage.leaseRejected', {
          name: latestLeaseReview.reviewer_name,
          date: toFriendlyDateString(latestLeaseReview.created_at),
        })}`}</div>
      }
      type="warning"
      description={
        <div>
          <div>{`${getTranslatedString('notes')}: ${latestLeaseReview.notes}`}</div>
          <div>
            {getTranslatedString('landlordPortal.leaseCreatorV2.leaseReview.reviewedByOn', {
              name: latestLeaseReview.reviewer_name,
              date: toFriendlyDateString(latestLeaseReview.created_at),
            })}
          </div>
        </div>
      }
    />
  );
};

export { LeaseRejectedAlert };
